import React from 'react';
import classNames from 'classnames';
import { Row } from 'reactstrap';

function Unauthenticated({ beginLogin, error }) {
    return (
        <Row className="justify-content-center unauthenticated">
            <div
                className={classNames(
                    'mt-4 card-title text-center text-light',
                    {
                        'd-none': error,
                    }
                )}>
                <h1 className="mt-4 card-title text-center text-light">
                    Welcome to Bitwerx SupportCo!
                </h1>
                <br />
                <h3 className="mt-4 card-title text-center text-light">
                    Please{' '}
                    <span
                        className="hoverable"
                        onClick={() => beginLogin()}
                        style={{
                            textDecoration: 'underline',
                            color: 'lightblue',
                        }}>
                        sign-in
                    </span>{' '}
                    to view more information.
                </h3>
            </div>
            <br />
            {error && (
                <div className="m-4 text-danger bg-light p-4 sc-rounded">
                    <h2 className="text-center mb-4">
                        We've run into an error :(
                    </h2>
                    <h6 className="mx-auto my-2 text-center">
                        As a quick fix, try&nbsp;
                        <span
                            className="hoverable"
                            onClick={() => beginLogin()}
                            style={{
                                textDecoration: 'underline',
                                color: 'blue',
                            }}>
                            signing in
                        </span>
                        &nbsp;again
                    </h6>
                    <div className="w-66 mx-auto">
                        <p>Error Type: {error.name}</p>
                        <p>Error Message: {error.errorMessage}</p>
                    </div>
                </div>
            )}
        </Row>
    );
}

export default Unauthenticated;
